import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Navgater from "../../components/Navgater";
import Tabbr from "../../components/Tabbr";
import Buttbar from "../../components/Buttbar";
import Btnundo from "../../components/Btnundo";
import Btnredo from "../../components/Btnredo";
import Btnpencil from "../../components/Btnpencil";
import Btnpalette from "../../components/Btnpalette";
import Btneraser from "../../components/Btneraser";
import Btnsave from "../../components/Btnsave";
import Btnnum from "../../components/Btnnum";
import Menubar from "../../components/Menubar";
import { useSelector } from "react-redux";
import Helpplate from "../../components/Helpplate";

export default function Rootstr() {
  const {expires,usern,menu}=useSelector((state)=>state.logininfo);
  
  return (
    <Container>
      <Row>
        <Col>
          <Navgater/>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col lg={6}>
          <Buttbar/>
        </Col>
        <Col lg={6}>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col lg={6}>
          <Tabbr/>
        </Col>
        <Col lg={6}>
          <Row xs={5} className="g-2 mt-0">
            <Col>
              <Btnundo/>
            </Col>
            <Col>
              <Btnpencil/>
            </Col>
            <Col>
              <Btnnum nu={1} />
            </Col>
            <Col>
              <Btnnum nu={2}/>
            </Col>
            <Col>
              <Btnnum nu={3}/>
            </Col>
            <Col>
              <Btnredo/>
            </Col>
            <Col>
              <Btnpalette/>
            </Col>
            <Col>
              <Btnnum nu={4}/>
            </Col>
            <Col>
              <Btnnum nu={5}/>
            </Col>
            <Col>
              <Btnnum nu={6}/>
            </Col>
            <Col>
              <Btnsave/>
            </Col>
            <Col>
              <Btneraser/>
            </Col>
            <Col>
              <Btnnum nu={7}/>
            </Col>
            <Col>
              <Btnnum nu={8}/>
            </Col>
            <Col>
              <Btnnum nu={9}/>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Helpplate/>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <div className="d-flex justify-content-start align-items-center">
          <img src='./pic/beian.png' alt='' width={'12px'} height={'12px'}/>
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44040202001517"
            target="_blank"
            rel="noreferrer"
            className="text-decoration-none text-reset mt-1 ms-1"
            style={{fontSize: '10px'}}>
              粤公网安备44040202001517号
          </a>
          <a href="https://beian.miit.gov.cn/" 
            target="_blank"
            rel="noopener noreferrer" 
            className="text-decoration-none text-reset mt-1 mx-3"
            style={{fontSize: '10px'}}>
              粤ICP备2023131992号
          </a>
        </div>
      </Row>
      {(expires>Date.now()&&menu) && <Menubar nu={{usern:usern}}/>}
    </Container>
  );
}
